module.exports = __webpack_public_path__ + "static/WEDDING E&M-181-417273239f0a2a2fc97f1aa79b062445.jpg";